export default new Set([
  "apeshit",
  "arsehole",
  "ass",
  "asshole",
  "assmunch",
  "bastard",
  "bastardo",
  "bastinado",
  "bitch",
  "bitches",
  "bollocks",
  "bullshit",
  "clusterfuck",
  "cunt",
  "darkie",
  "dick",
  "fag",
  "f-a-g",
  "f.a.g",
  "f4g",
  "f.u.c.k",
  "ufck",
  "fck",
  "fvck",
  "faggot",
  "fuck",
  "f*ck",
  "f**k",
  "f***k",
  "fcuk",
  "jigaboo",
  "jiggaboo",
  "jiggerboo",
  "kike",
  "motherfucker",
  "negro",
  "nigga",
  "nigger",
  "nig nog",
  "poof",
  "pussy",
  "slanteye",
  "slut",
  "tit",
  "tits",
  "titties",
  "titty",
  "tranny",
  "twat",
  "wank",
  "wetback",
]);
